




































































































































import { Component, Vue } from 'vue-property-decorator'
import ModalShowProfile from '@/components/Modal/ModalShowProfile.vue'
import { Member, EMemberRole, IUserGroupRole, UserProfile } from '@/models'
import GroupMemberService from '@/services/GroupMemberService'
import ModalUpdateAuthorTopic from '@/components/Modal/ModalUpdateAuthorTopic.vue'
import { handleMemberLoginStatus } from '@/helpers/Common'
/**
 * f2-301
 * グループメンバー一覧画面
 */
@Component({ components: { ModalShowProfile, ModalUpdateAuthorTopic } })
export default class MemberList extends Vue {
  memberList: Member[] = []
  memberCount = 0
  private eRole = EMemberRole
  page: number = 1
  maxPage: number = 1
  noAvatar = require('@/assets/images/avatar-default.png')
  selectedUserId: number = -1
  private limit: number = this.$store.state.setting.setting.setting_display
    .number_item_lists
  modalMess: string = ''
  modalAction = () => {}
  kickMemberId: number = -1

  get isRoleAdmin() {
    return this.$store.state.userInfo.user.group_role.role_admin
  }

  get isTryingToKickMember() {
    return this.kickMemberId !== -1
  }

  memberRoleWidth = 70
  memberLastLoginWidth = 160
  memberDeleteWidth = 28

  created() {
    this.getAllMember()

    const currentLanguage = this.$store.state.setting.setting.setting_language
      .code

    if (currentLanguage === 'en') {
      this.memberRoleWidth = 115
      this.memberLastLoginWidth = 128
      this.memberDeleteWidth = 40
    }
  }

  /**
   * Call API get all member of group
   */
  getAllMember(loadMore?: boolean) {
    GroupMemberService.getAllMembersByGroupId({
      groupId: this.$route.params.groupId,
      page: this.page,
      limit: this.limit
    })
      .then(res => {
        if (res.status === 200) {
          const data = res.data.data.map((item: any) => new Member(item))
          if (loadMore) {
            this.memberList = [...this.memberList, ...data]
          } else {
            this.memberList = data
          }
          this.maxPage = res.data.last_page
          this.memberCount = res.data.total
        }
      })
      .catch(err => {
        this.modalMess = this.$t('common.message.uncatch_error') as string
        this.$bvModal.show('modal-error')
      })
  }

  /**
   * Call API for loadmore
   */
  loadMore() {
    ++this.page
    this.getAllMember(true)
  }

  async showMemberProfile(profile?: UserProfile) {
    this.selectedUserId = profile ? profile.user_id : -1
    this.$bvModal.show('modal-show-profile')
    // }
  }

  getUserAvatarSmall(user: any): string {
    return user && user.user_profile && user.user_profile.avatar_small
      ? user.user_profile.avatar_small
      : ''
  }

  /**
   * Check user is same group tag
   */
  // async getUserProfileById() {
  //   return UserService.getUserProfileById(this.selectedUserId)
  //     .then(res => {
  //       return res.status === 200 && res.data.is_same_group_tag
  //     })
  //     .catch(() => {
  //       return false
  //     })
  // }

  confirmDeleteMember(memberId: number) {
    this.kickMemberId = memberId
    this.modalMess = this.$t('common.message.delete') as string
    this.modalAction = () => this.checkUserHasCreateAnyTopic()
    this.$bvModal.show('modal-confirm-member-list')
  }

  async handleRemoveMember() {
    this.$blockui.show()
    GroupMemberService.removeMember(
      this.$route.params.groupId,
      this.kickMemberId
    )
      .then(res => {
        if (res.status === 200) {
          this.memberList = this.memberList.filter(
            item => item.id !== this.kickMemberId
          )

          this.modalMess = this.$t('common.message.deleted') as string
          this.modalAction = () => {}
          this.$bvModal.show('modal-success')
        }
      })
      .catch(err => {
        if (err.response.status === 404) {
          this.memberList = this.memberList.filter(
            item => item.id !== this.kickMemberId
          )

          this.modalMess = this.$t(
            'common.message.member_not_in_group'
          ) as string
          this.$bvModal.show('modal-error')
        } else if (
          err.response.status === 422 &&
          err.response.data &&
          err.response.data.message === 'GROUP_MUST_HAVE_AT_LEAST_ONE_ADMIN'
        ) {
          // NWS-1791 当面対応: 削除するとグループ管理者が0人になる場合。
          // 一覧からは消さず、理由を明示して操作を止める。
          this.modalMess = this.$t(
            'common.message.cant_delete_last_admin'
          ) as string
          this.$bvModal.show('modal-error')
        } else if (this.isJoinedByOtherTag(err)) {
          // NWS_SMILELINE-2011: 「Ct全社」などのタグで参加している人は、ここからは削除できない（タグを消さない）。
          // 一覧からは消さず、理由のタグを示して止める。
          this.modalMess = this.joinedByOtherTagMessage(err, true)
          this.$bvModal.show('modal-error')
        } else {
          this.modalMess = this.$t('common.message.delete_fail') as string
          this.$bvModal.show('modal-error')
        }
      })
      .finally(() => {
        this.$blockui.hide()
      })
  }

  leaveGroupModalConfirm() {
    // reset member id
    this.kickMemberId = -1
    this.$bvModal.show('modal-confirm-member-list')
    this.modalMess = this.$t('common.message.leave_group') as string
    this.modalAction = () => this.handleLeaveGroup()
  }

  async checkUserHasCreateAnyTopic() {
    try {
      this.$blockui.show()
      const response = await GroupMemberService.checkUserHasCreateAnyTopic(
        this.$route.params.groupId,
        this.isTryingToKickMember ? this.kickMemberId : undefined
      )
      if (response.status === 200) {
        // user has created topics
        if (response.data.data) {
          this.$blockui.hide()
          await (this.$refs
            .updateAuthorTopicModalRef as any).getMemberListWithoutMemberRole()
          this.$bvModal.show('update-author-topic')
        } else if (this.isTryingToKickMember) {
            this.handleRemoveMember()
          } else {
            this.leaveGroup()
          }
      }
    } catch (err) {
      // NWS_SMILELINE-2011: タグで参加している人の削除・退出は、掲示板の付け替えの前にサーバが断る
      if (this.isJoinedByOtherTag(err)) {
        this.modalMess = this.joinedByOtherTagMessage(err, this.isTryingToKickMember)
        this.$bvModal.show('modal-error')
      } else {
        throw err
      }
    } finally {
      this.$blockui.hide()
    }
  }

  // NWS_SMILELINE-2011: マスタータグ以外のタグ（「Ct全社」など）で参加しているため、削除・退出できないとサーバが返したか
  isJoinedByOtherTag(err: any): boolean {
    return !!(
      err &&
      err.response &&
      err.response.status === 422 &&
      err.response.data &&
      err.response.data.code === 'MEMBER_JOINED_BY_OTHER_TAG'
    )
  }

  joinedByOtherTagMessage(err: any, byAdmin: boolean): string {
    const names: string[] = Array.isArray(err.response.data.tag_names)
      ? err.response.data.tag_names
      : []
    // タグの名前は 3 つまで出し、それより多いときは「ほか」を付ける
    const tags = names
      .slice(0, 3)
      .join(String(this.$t('common.message.joined_by_other_tag_separator')))
    const more =
      names.length > 3
        ? String(this.$t('common.message.joined_by_other_tag_more'))
        : ''
    return String(
      this.$t(
        byAdmin
          ? 'common.message.cant_delete_joined_by_other_tag'
          : 'common.message.cant_leave_joined_by_other_tag',
        { tags, more }
      )
    )
  }

  onUpdateAuthorTopic(userIdToTranfser: number) {
    // this.$blockui.show()
    let payload: any = {
      user_id: userIdToTranfser
    }

    if (this.isTryingToKickMember) {
      payload.user_leave = this.kickMemberId
    }
    GroupMemberService.updateAuthorTopicLeaveGroup(
      this.$route.params.groupId,
      payload
    )
      .then(response => {
        if (response.status === 200) {
          if (this.isTryingToKickMember) {
            this.handleRemoveMember()
          } else {
            this.leaveGroup()
          }
        }
      })
      .finally(() => this.$blockui.hide())
  }

  async handleLeaveGroup() {
    if (this.memberCount === 1) {
      this.modalMess = String(this.$t('common.message.cant_leave_one_mem'))
      this.$bvModal.show('modal-info')
      return
    }
    const groupRole: IUserGroupRole = this.$store.state.userInfo.user.group_role
    if (
      String(groupRole.group_id) === this.$route.params.groupId &&
      !groupRole.role_admin
    ) {
      this.checkUserHasCreateAnyTopic()
    } else {
      const checkAdminOther = await this.checkAdminOther()
      if (checkAdminOther) {
        this.checkUserHasCreateAnyTopic()
      }
    }
  }

  async checkAdminOther() {
    const groupId = this.$route.params.groupId
    return GroupMemberService.findAdminWithoutMe(groupId)
      .then(res => {
        return res.status === 200
      })
      .catch(err => {
        const groupRole: IUserGroupRole = this.$store.state.userInfo.user
          .group_role
        if (
          err.response.status === 404 &&
          String(groupRole.group_id) === groupId &&
          groupRole.role_admin
        ) {
          this.modalMess = String(this.$t('common.message.set_admin'))
          this.$bvModal.show('modal-info')
        }
      })
  }

  leaveGroup() {
    this.$blockui.show()
    GroupMemberService.leaveCurrentGroup(this.$route.params.groupId)
      .then(res => {
        if (res.status === 200) {
          this.modalMess = String(this.$t('common.message.deleted'))
          this.modalAction = () => this.jupmToHome()
          this.$bvModal.show('modal-success')
        }
      })
      .catch(err => {
        // NWS-1791 当面対応: グループ管理者が自分1人だけの場合、サーバが422で拒否する。
        // NWS-1827: 稼働中メンバーが自分1人だけの場合も同様に422で拒否する。
        // 画面側の事前チェック(memberCount)は表示用件数に依存していて信用できない
        // (「管理者を非表示」設定のグループでは管理者が数えられない)ため、
        // 取りこぼしはここで受け止める。
        if (
          err.response &&
          err.response.status === 422 &&
          err.response.data &&
          err.response.data.message === 'GROUP_MUST_HAVE_AT_LEAST_ONE_ADMIN'
        ) {
          this.modalMess = String(
            this.$t('common.message.cant_leave_last_admin')
          )
        } else if (
          err.response &&
          err.response.status === 422 &&
          err.response.data &&
          err.response.data.message === 'GROUP_MUST_HAVE_AT_LEAST_ONE_MEMBER'
        ) {
          this.modalMess = String(this.$t('common.message.cant_leave_one_mem'))
        } else if (this.isJoinedByOtherTag(err)) {
          // NWS_SMILELINE-2011: タグで参加しているため退出できない（タグを消さない）
          this.modalMess = this.joinedByOtherTagMessage(err, false)
        } else {
          this.modalMess = String(this.$t('common.message.delete_fail'))
        }
        this.$bvModal.show('modal-error')
      })
      .finally(() => this.$blockui.hide())
  }

  getFullName(profile?: UserProfile) {
    const name = [
      profile?.first_name,
      profile?.last_name,
      String(this.$t('groups.member_list.name_suffix'))
    ].join(' ')
    return name
  }

  jupmToHome() {
    this.$router.push({ name: 'home' })
  }

  handleMemberRole(member: Member) {
    if (member.isAdmin) {
      return this.$t('groups.member_list.role_admin')
    }

    if (member.user_permissions.length !== 0) {
      return this.$t('groups.member_list.role_member_plus')
    }

    return this.$t('groups.member_list.role_member')
  }

  handleLoginStatus(member: Member) {
    return handleMemberLoginStatus({
      lastLoginAt: member?.last_login_at,
      tobeLoggedOut: !!member?.to_be_logged_out,
      isCurrentUser: member.id === this.$store.state.userInfo.user.info.id,
      isOnline: member?.is_online,
      lastAccessAt: member?.last_access_at,
      agoSeconds: member?.last_access_ago_sec
    })
  }
}
